<div class="cs-cb-wave logo-animation-wrapper">
  <div class="loading">
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
  </div>
</div>
<style lang="scss">
  @use './../../../../scss/components/themes/loading-theme/loading-wave-theme';
</style>
